import { Pipe, PipeTransform } from '@angular/core';
import { ProjectLanguage } from '../../firestore-models/project-language';

@Pipe({
  name: 'multiUserInputTitle',
  standalone: false,
})
export class MultiUserInputTitlePipe implements PipeTransform {

  transform(values: Array<{lang_code: string, user_input_title: string}>, languages: Array<ProjectLanguage>,currentLang: string = 'ja'): string {
    let user_input_title: string = '';
    if (!!values) {
      const language = languages.find(lang => lang.lang_code === currentLang);//#216 日本語固定になっているので、admin_lang_modeに従って出し分ける
      // const language = languages[0];
      if (language) {
        for (const value of values) {
          if (language.lang_code === value.lang_code) {
            user_input_title = value.user_input_title;
            break;
          }
        }
      }
    }
    return user_input_title;
  }

}
